import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
import LOGO from '../../assets/logo.png'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'><img src={LOGO} alt="logo" /></a>
      {/* <a href="#" className='footer__logo'>BADIEN VANESSA</a> */}

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/profile.php?id=100092382326501" target="_blank"><FaFacebookF/></a>
        <a href="https://linkeding.com" target="_blank"><FiInstagram/></a>
        <a href="https://twitter.com/BadienVanessa" target="_blank"><IoLogoTwitter/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy;BADIEN VANESSA — Salesforce Developer & CRM Consultant | Web Developer | CPQ Specialist | 9x Salesforce Certified. All Rights Reserved.</small>
      </div>
    </footer >
  )
}

export default Footer